var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMelhorEnvio01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 522.5 240.8",
    style: {
      enableBackground: "new 0 0 522.5 240.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#004E9F;}\r\n\t.st1{fill:#FFB30E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "melhorenvio",
    transform: "matrix(2.304505,0,0,2.304505,88.701929,229.91121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    className: "st0",
    d: "M141.6-83.4v6.3c-3.5,0-6.3,2.8-6.3,6.3v19.6H129v-19.5C129-77.7,134.6-83.4,141.6-83.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    className: "st0",
    d: "M-6.9-83.4c-3.8,0-7.2,1.7-9.5,4.3c-2.3-2.6-5.7-4.3-9.5-4.3c-7,0-12.6,5.7-12.6,12.6v19.6h6.3 v-19.5c0-3.5,2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3v19.6h6.3v-19.6c0-3.5,2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3v19.6h6.3v-19.6 C5.7-77.7,0.1-83.4-6.9-83.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    className: "st0",
    d: "M58.8-51.2v-6.3c-3.5,0-6.3-2.8-6.3-6.3v-35.7h-6.3v35.7C46.2-56.8,51.8-51.2,58.8-51.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "st0",
    d: "M75.6-83.4c-2.3,0-4.5,0.6-6.3,1.7v-17.7H63v28.7v19.6h6.3v-19.6c0-3.5,2.8-6.3,6.3-6.3 s6.3,2.8,6.3,6.3v19.6h6.3v-19.6C88.3-77.7,82.6-83.4,75.6-83.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "st0",
    d: "M41.6-70.4c-1.5-7.3-7.9-12.8-15.7-12.8s-14.2,5.5-15.7,12.8c-0.2,1-0.3,2.1-0.3,3.2 s0.1,2.1,0.3,3.2c1.5,7.3,7.9,12.8,15.7,12.8c5.3,0,10-2.6,12.9-6.5l-5.1-3.7c-1.8,2.4-4.6,3.9-7.8,3.9c-4.3,0-7.9-2.7-9.2-6.5 h24.9c0.2-1,0.3-2.1,0.3-3.2C42-68.3,41.8-69.3,41.6-70.4 M25.9-76.9c4.3,0,7.9,2.7,9.2,6.5H16.8C18.1-74.2,21.7-76.9,25.9-76.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    className: "st0",
    d: "M108.7-83.4c-8.9,0-16.1,7.2-16.1,16.1s7.2,16.1,16.1,16.1s16.1-7.2,16.1-16.1 C124.8-76.2,117.6-83.4,108.7-83.4 M108.7-57.5c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8s9.8,4.4,9.8,9.8S114.1-57.5,108.7-57.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect14",
    x: 128.7,
    y: -44.6,
    className: "st0",
    width: 6.3,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "st0",
    d: "M58.5-31.7C57-39,50.6-44.5,42.9-44.5s-14.2,5.6-15.6,12.8c-0.2,1-0.3,2.1-0.3,3.2 s0.1,2.1,0.3,3.2c1.5,7.3,7.9,12.8,15.6,12.8c5.3,0,9.9-2.5,12.8-6.5l-5-3.7c-1.8,2.4-4.6,3.9-7.8,3.9c-4.2,0-7.8-2.7-9.1-6.5h24.8 c0.2-1,0.3-2.1,0.3-3.2C58.8-29.6,58.7-30.6,58.5-31.7 M42.9-38.2c4.2,0,7.8,2.7,9.1,6.5H33.8C35.1-35.4,38.7-38.2,42.9-38.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    className: "st0",
    d: "M75.6-44.7c-7,0-12.6,5.7-12.6,12.6v19.6h6.3v-19.6c0-3.5,2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3v19.6 h6.3v-19.6C88.3-39.1,82.6-44.7,75.6-44.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "st0",
    d: "M155.3-44.7c-8.9,0-16.1,7.2-16.1,16.1s7.2,16.1,16.1,16.1c8.9,0,16.1-7.2,16.1-16.1 C171.4-37.5,164.2-44.7,155.3-44.7 M155.3-18.9c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c5.4,0,9.8,4.4,9.8,9.8 C165.1-23.2,160.7-18.9,155.3-18.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon22",
    className: "st0",
    points: "117.8,-44.3 108.7,-21.4 99.5,-44.3 92.6,-44.3 105.8,-12.6 111.5,-12.6 124.8,-44.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    className: "st0",
    d: "M141.6-83.4v6.3c-3.5,0-6.3,2.8-6.3,6.3v19.6H129v-19.5C129-77.7,134.6-83.4,141.6-83.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    className: "st1",
    d: "M188.2-45.2L188.2-45.2c-0.1-1.9-0.8-3.7-2-5.3v-0.1c-3.4-4.4-8.9-4.8-14-4.9 c2.4-3.6,5.6-8.7,5.7-15.2c0.1-4.6-1.3-8.7-4-11.4c-1-1-2.2-1.8-3.5-2.4s-2.6-0.9-4.1-0.9c-2.8-0.1-5.5,1-7.6,3.1s-2.8,4.7-3.4,6.9 v0.1l0,0c-0.4,1.7-1.1,3.2-2.2,4.6l-1.5,2l-0.5,0.6L151-68c-0.1,0.1-0.2,0.3-0.4,0.4c-0.2,0.2-0.3,0.4-0.5,0.6 c-1.2,1.4-2.6,2.9-4.3,4.4h-0.1c-1.6,1.5-3.4,3-4.9,4.3v4.3v2.8c0,0,6.3-4.6,8.9-7c1.9-1.7,3.6-3.5,4.9-5l0.1-0.2 c0.1-0.1,0.2-0.3,0.4-0.4c0.2-0.2,0.3-0.4,0.5-0.7l0.5-0.6l2-2.7c1.1-1.6,2-3.3,2.5-5.2c0.1-0.3,0.2-0.7,0.3-1.1 c0.5-1.7,0.8-3.2,1.9-4.2c0.2-0.2,0.5-0.4,0.9-0.6c0.7-0.3,2.3-0.7,3.7-0.4c1.2,0.2,2.2,1.1,2.3,1.2c1.5,1.5,2.4,4.1,2.3,7.1l0,0 c-0.1,5.4-3.1,9.7-5.3,12.9l-0.3,0.4c-1,1.2-1.6,2.4-2.2,3.6l-1.7,3.8l4.2,0.3c0.7,0.1,1.5,0.1,2.2,0.1s1.3,0,1.9,0.1h0.2 c4.6,0.1,8.6,0.2,10.4,2.6c0.5,0.8,0.8,1.5,0.9,2.2c0.1,1.2-0.1,2.3-0.5,3.4c-0.8,2.1-1,4.5-0.6,6.8c0.2,1,0.2,2.1,0,3l0,0 c-0.2,1.4-0.9,2.9-2,4.4c-0.4,0.5-0.9,1.2-1.2,2.1l-0.1,0.2c-0.3,0.9-0.5,1.9-0.5,2.9c0,0.9-0.5,2.3-0.9,3.3s-0.9,1.9-1.6,2.7 c-0.5,0.7-1.2,1.5-1.7,1.9l-0.1,0.1c-0.5,0.4-1.3,1.1-1.8,1.9l-0.1,0.1l-0.2,0.3c-2.1,3.2-3.4,5.2-5.4,6.9 c-1.6,1.4-3.6,2.3-5.7,2.8c-0.6,0.2-1.2,0.3-1.8,0.4c-1.5,0.2-3,0.4-4.3,0.4c-4.8,0.3-9.8-0.3-14.6-1.5l0,0 c-2.7-0.6-6.2-1.4-10-1.7h-2.5L27.4-4.7c-0.6,0-0.6,0.9,0,0.9l101.3,4.9c3.3,0.3,6.6,1,9,1.6c5.3,1.3,10.7,2,16.3,2 c1.8,0,3.5-0.2,5.1-0.4l0,0c0.8-0.1,2.3-0.5,3.5-0.8c1.5-0.4,2.9-1,4.1-1.7c4.4-2.6,6.3-5.5,9.1-9.9l0.3-0.5 c0.1-0.1,0.3-0.4,0.6-0.7c1.7-1.3,3.2-2.9,4.2-4.8c1.5-2.3,2.3-5,2.3-7.8c0-0.3,0.1-0.7,0.1-1c0.1-0.2,0.3-0.5,0.4-0.7 c1.7-2.2,2.7-4.6,3.1-7c0.3-1.6,0.3-3.2,0-4.9v-0.1c-0.2-1.4-0.1-2.7,0.3-3.8l0,0C188.1-41.3,188.4-43.2,188.2-45.2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMelhorEnvio01);
export default __webpack_public_path__ + "static/media/logo_melhor_envio-01.90da06e1e8b5e72a58193a09b8ce6847.svg";
export { ForwardRef as ReactComponent };